import axios from 'axios'

export const generateSoapNotesDocument = async (payload) => {
  const data = JSON.stringify(payload)
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/googleapis-createSoapNotesDocument`,
    // url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/createMedicalDirectiveGoogleDoc`,
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  }

  const response = await axios(config)

  return response?.data || response
}

export const zapierSetSOAPFormDetails = async (data) => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/zapierSetSOAPFormDetails`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data,
  }
  const response = await axios(config)
  return response?.data || response
}
export const sendToUserLabAndImaging = async (data) => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/webhook-sendToUserLabAndImaging`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data,
  }
  const response = await axios(config)
  return response?.data || response
}

export const mergePdfs = async (payload) => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/webhook-merge_pdfs`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: payload,
  }

  const response = await axios(config)
  return response?.data || response
}


export const delegateChatCloseTask = async (payload) => {
  const data = JSON.stringify(payload)
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/doctorDashboard-delegateChatCloseTask`,
    // url: `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL_NA}/createMedicalDirectiveGoogleDoc`,
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  }

  const response = await axios(config)

  return response?.data || response
}